import { HttpMethod } from '@nu-art/thunderstorm-shared';
export const ApiDef_RuntimeSmartNote = {
    get: { method: HttpMethod.POST, path: '/encounter-manager/get-smart-note' },
    save: { method: HttpMethod.POST, path: '/encounter-manager/save-smart-note' },
    writeBack: { method: HttpMethod.POST, path: '/encounter-manager/smart-note-write-back' },
};
//# sourceMappingURL=api-def.js.map